export default __webpack_public_path__ + "static/media/totalemployees-icon.a1f10283.svg";